import React from 'react'
import ReactDOM from 'react-dom/client'
import Dashboard from './pages/Dashboard'
import { autoSetup } from './lib/api'
import './ui/styles/tokens.css'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

/* Récupère le token depuis le daemon local avant de monter l'app */
autoSetup().finally(() => {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <Dashboard />
    </React.StrictMode>
  )
})
